import { Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Signer } from 'crypto';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { EnumContractUserRole, EnumContractUserStatus } from 'src/app/core/constants/contract';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { DigitalCertificateService } from 'src/app/core/services/digital-certificate.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningComponent } from '../warning/warning.component';

@Component({
  selector: 'app-forward-sign-dialog',
  templateUrl: './forward-sign-dialog.component.html',
  styleUrls: ['./forward-sign-dialog.component.scss']
})
export class ForwardSignDialogComponent implements OnInit {
  forwardSignForm: FormGroup

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<ForwardSignDialogComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    private commonService: CommonService,
    private digitalCertificateService: DigitalCertificateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public autoUserService: AutoUserService,
    private contractService: ContractService,
    private location: Location
  ) {
    // Get data from ViewDocumentComponent
    this.submission.idContract = data.id;
    this.documentName = data.name;
    this.isAutoSign = data.isAutoSign;
    this.userSign = data.userSign;
    this.contractId = data.contractId;
    dialogRef.disableClose = false;
    this.userId = localStorage.getItem('userId');
  }

  submission = {
    idContract: '',
    idSigner: ''
  };

  documentName: '';
  name: '';
  success = false;
  isAutoSign = false;
  // Columns of table
  displayedColumns: string[] = ['fullName', 'userName', 'enterprise'];
  // Data for table
  signers: Signer[];
  hasDigitalCertificateServer = false;
  // current status when signed
  isCurrentStatus = 1;
  page: number;
  pageSize: number;
  routeLink: string;
  enterprise: '';
  documentTypeSearch: '';
  nameOrCode: '';
  customerName: '';
  status: '';
  serviceType: '';
  taxCode: '';
  createdUser: '';
  createdTimeFrom: '';
  createdTimeTo: '';
  finishDateFrom: '';
  finishDateTo: '';
  sortDirection: '';
  sortColumn: '';
  goFrom: '';
  inputPartyValue: any;
  filteredPartyOptions: any;
  nzCheckLoadingParty: boolean;
  nzCheckLoadingUser: boolean;
  filteredUserOptions: any;
  initialInfo: any;
  inputUserValue: string;
  isFormChanging: boolean;
  private userId: string;
  private contractId: string;
  private userSign = [];
  idTimeout = null;
  DEFAULT_ROUTER_ON_BACK_LIST = '/home-enterprise/search-document-sign';
  urlGoBack = this.DEFAULT_ROUTER_ON_BACK_LIST;
  ngOnInit() {
    // this.getSigners(this.data.id);
    this.notificationService.subscribeErrorService();
  }

  onChangeUserSignSearch(event): void {
    if (this.idTimeout) {
      clearTimeout(this.idTimeout);
    }

    setTimeout(
      () => {
        if (event.trim().length > 0) {
          this.nzCheckLoadingUser = true;
          this.autoUserService.fetchAutoForwardSign(event.trim(), this.contractId)
            .then(result => {
              let listIdApproval = this.userSign.filter(item => item.role === EnumContractUserRole.APPROVE && item.status !== EnumContractUserStatus.PROCESSING);
              listIdApproval = listIdApproval.map(item => item.userId);
              this.filteredUserOptions = result.filter(item => (item.id !== this.userId) && !listIdApproval.includes(item.id));
            }).finally(() => {
            this.nzCheckLoadingUser = false;
          });
        } else {
          this.filteredUserOptions = [];
        }
      }, 250
    );
  }

  saveSubmission() {
    if (this.isAutoSign) {
      // this.digitalCertificateService.getServerCertificatesWithSigner(this.submission.idSigner).subscribe(rs => {
      //   this.hasDigitalCertificateServer = rs && rs.data && rs.data.length > 0;
      //   const messageKey = this.hasDigitalCertificateServer ? 'messages.confirm_submission_has_cts' : 'messages.confirm_submission_no_cts';
      //   const warning = {width: '30%', data: this.message.getMessage(messageKey)};
      //   this.dialog.open(WarningComponent, warning).afterClosed().subscribe(confirmResult => {
      //     if (confirmResult) {
      //       this.docSaveSubmission(this.hasDigitalCertificateServer);
      //     }
      //   });
      // });
    } else {
      this.confirmSubmit();
    }
  }

  highlight(row) {
    this.submission.idSigner = row.id;
    this.name = row.name;
  }

  docSaveSubmission(autoSign: boolean = false) {
    this.documentService.saveSubmission(this.submission)
      .subscribe(res => {
        this.success = true;
        if (autoSign) {
          this.toastr.success(this.message.getMessage('messages.submission_auto_sign'));
        } else {
          this.toastr.success(this.message.getMessage('messages.submission'));
        }
        this.dialogRef.close();
      });
  }

  confirmSubmit() {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_change_submission'),
        '<strongdocSaveSubmission>' + this.documentName + '</strongdocSaveSubmission>', '<strong>' + this.name + '</strong>')
    });

    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.docSaveSubmission();
      }
    });
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  cancel() {
    this.dialogRef.close();
  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '30%',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }


  autocompleteUserSelected($event, user: any) {
    if ($event.isUserInput) {
      this.isFormChanging = true;
      this.initialInfo = user;
      // console.log('user', user)
    }
  }

  onClickBtnConfirm() {

    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('forward_sign.confirm_forward_sign'), this.initialInfo.fullName)
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        const data = {
          contractId: this.data.id,
          userId: this.initialInfo.id
        };

        this.contractService.addUserForwardSign(data).subscribe(result => {
          if(!result.success){
            this.toastr.error(result.message); 
            if(result.code == ErrorCode.ForwardSignFailed){
              this.dialogRef.close(true);
              this.location.back()
            }
            return
          }
          this.toastr.success(this.message.getMessage('forward_sign.forward_sign_success'));
          this.dialogRef.close(true);
          this.router.navigate([this.urlGoBack]);
        });
      }
    });

  }

  onClickCancelButton() {

  }
}
